<!-- Regione dinamica cortese: la comparsa dopo il rimbalzo da una rotta
     protetta va annunciata senza interrompere (WCAG 4.1.3). Non è un titolo:
     la gerarchia dei titoli resta quella della pagina. -->
<div class="auth-notice" role="status" aria-live="polite" *ngIf="initState.noticeVisible()">
  <i class="pi pi-exclamation-triangle auth-notice__icon" aria-hidden="true"></i>
  <div class="auth-notice__body">
    <p class="auth-notice__title">Accesso non riuscito</p>
    <p class="auth-notice__text">
      Il servizio di autenticazione non ha completato l'accesso. Piani e carrello
      restano disponibili senza account; puoi riprovare quando vuoi.
    </p>
  </div>
  <div class="auth-notice__actions">
    <p-button label="Riprova l'accesso" size="small" [outlined]="true" (onClick)="retry()"></p-button>
    <p-button
      label="Chiudi avviso"
      size="small"
      severity="secondary"
      [text]="true"
      (onClick)="dismiss()"
    ></p-button>
  </div>
</div>
